import React, { Component } from 'react'
import { MapStyle } from './MapStyle'
import MapMarker from './MapMarker'

/*
 * Documentation can be found here:
 * https://googlemaps.github.io/js-markerclusterer/classes/MarkerClusterer.html
 *
 * The Marker class is undocumented there, and can be found here instead:
 * https://developers.google.com/maps/documentation/javascript/reference/marker
 */

const google = window.google

class Map extends Component {
  constructor(props) {
    super(props)

    this.markers = []
  }

  render() {
    return (
      <div className="c-map">
        <div id="map-canvas" className="c-map__canvas" />
      </div>
    )
  }

  // Create map after component is rendered
  componentDidMount() {
    this.map = this.createMap()

    const styles = [
      {
        textColor: '#FFFFFF',
        textSize: '16px',
        url: '/Frontend/Renewi/dist/img/markerclusters/m1.png',
        height: 50,
        width: 50
      },
      {
        textColor: '#FFFFFF',
        textSize: '16px',
        url: '/Frontend/Renewi/dist/img/markerclusters/m2.png',
        height: 56,
        width: 56
      },
      {
        textColor: '#FFFFFF',
        textSize: '16px',
        url: '/Frontend/Renewi/dist/img/markerclusters/m3.png',
        height: 66,
        width: 66
      }
    ];

    const renderer = {
      render: ({ count, position, ...rest }) => {
        const index = Math.round(Math.log(count) / Math.log(this.props.searchResults.length) * (styles.length - 1));

        return new google.maps.Marker({
          label: {
            text: String(count),
            color: styles[index].textColor,
            fontSize: styles[index].textSize,
          },
          icon: {
            url: styles[index].url,
            size: {
              width: styles[index].width,
              height: styles[index].height,
            },
          },
          position,
          // adjust zIndex to be above other markers
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
      }
    }

    this.markerCluster = new markerClusterer.MarkerClusterer({
      map: this.map,
      markers: [],
      renderer,
      ...styles,
    });


    this.setMarkers(this.props.searchResults)
  }

  componentWillUpdate(nextProps, nextState) {
    // If searchResults changes
    if (this.props.searchResults !== nextProps.searchResults) {
      this.clearMarkers()

      if (nextProps.searchResults.length > 0) {
        this.setMarkers(nextProps.searchResults)
        this.zoomToPositionByMarkers(nextProps.geometry)
      }
    }

    // If selectedSearchResult changes
    if (this.props.selectedSearchResult !== nextProps.selectedSearchResult) {
      // TODO set markers inactive
      this.setMarkersInactive()

      if (nextProps.selectedSearchResult != null) {
        // Get index of SelectedSearchResult in Markers-Array
        const marker = this.markers.find(function(m) {
          return m.id == nextProps.selectedSearchResult.Id
        })
        // Activate marker on map
        marker.setMarkerActive()
        this.zoomToPositionBySelectedMarker(nextProps.geometry)
      } else {
        // show all searchresults on map
        this.zoomToPositionByMarkers(nextProps.geometry)
      }
    }
  }

  createMap() {
    let mapOptions = {
      center: new google.maps.LatLng(52.370216, 4.895168),
      zoom: 8,
      styles: MapStyle,
      disableDefaultUI: true,
      zoomControl: true
    }
    return new google.maps.Map(
      document.getElementById('map-canvas'),
      mapOptions
    )
  }

  zoomToPositionBySelectedMarker(geometry) {
    this.map.setCenter(geometry)
    this.map.setZoom(14)
  }

  zoomToPositionByMarkers(geometry) {
    // Set zoomlevel and center map
    this.map.setCenter(geometry)
    this.map.setZoom(11)

    // Get current Google Maps bounds
    let currentBounds = this.map.getBounds()

    // Loop through markers and extend current bound
    for (let marker of this.markers) {
      currentBounds = currentBounds.extend(marker.getPosition())
    }

    // Fit map to new bounds
    this.map.fitBounds(currentBounds)
  }

  setMarkers(locations) {
    for (let location of locations) {
      // Initialize new marker
      const marker = new MapMarker(location, this.map)
      this.markers.push(marker)
      this.markerCluster.addMarker(marker)
    }
  }

  clearMarkers() {
    this.markers = []
    this.markerCluster.clearMarkers()
  }

  setMarkersInactive() {
    for (let marker of this.markers) {
      // Set marker to inactive
      marker.setMarkerInactive()
    }
  }
}

export default Map
